module.exports = __webpack_public_path__ + "static/signup-og-image-50cbd340f6992592f54c55866f09d65f.jpg";